<mat-icon
  [class.success]="enabled && !disabledDueToAccess"
  [class.warning]="enabled && disabledDueToAccess"
  [class.muted]="!enabled"
  [title]="getTitle()">
  check_circle
</mat-icon>
